import { MAX_IMAGE_FILE_SIZE } from '@/app/constants';
import { formatFileSize } from '../index';
import type { ImageValidationReason } from './validate-image-file';

/**
 * 把结构化的图片校验失败原因翻译成用户可见文案。
 *
 * 不直接调用 `useTranslations`，由调用方传入 `t`，保持纯函数特性。
 */
export function getImageValidationErrorMessage(
  reason: ImageValidationReason,
  opts: {
    t: (key: string, values?: Record<string, string | number | Date>) => string;
    maxFileSize?: number;
  },
): string {
  const { t, maxFileSize = MAX_IMAGE_FILE_SIZE } = opts;
  switch (reason) {
    case 'invalidType':
      return t('create.createForm.upload.error.invalidType');
    case 'incorrectExtension':
      return t('create.createForm.upload.error.incorrectExtension');
    case 'invalidSize':
      return t('create.createForm.upload.error.invalidSize', { limit: formatFileSize(maxFileSize) ?? '' });
    case 'invalidArea':
      return t('create.createForm.upload.error.invalidArea');
    case 'invalidRatio':
      return t('create.createForm.upload.error.invalidRatio');
    case 'invalidImage':
      return t('create.createForm.upload.error.invalidImage');
    default:
      return t(`create.createForm.upload.error.${reason}`);
  }
}
